import isMobile from '../../utils/is-mobile';

export default {
  methods: {
    translate(k) {
      if (!isMobile()) return this.$t(k);
      const mobileKey = `mobile.${k}`;
      const mobileTranslation = this.$t(mobileKey);
      return mobileTranslation === mobileKey ? this.$t(k) : mobileTranslation;
    }
  }
};
